window.addEventListener('scroll', throttle(parallax, 14));

function throttle(fn, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
};

function inViewport (element) {
    if (!element) return false;
    if (1 !== element.nodeType) return false;
  
    var html = document.documentElement;
    var rect = element.getBoundingClientRect();
  
    return !!rect &&
      rect.bottom >= 0 &&
      rect.right >= 0 && 
      rect.left <= html.clientWidth &&
      rect.top <= html.clientHeight;
}

function parallax() {
  var parallax = document.querySelectorAll(".parallax");
  var scrolled = window.pageYOffset;
  // You can adjust the 0.4 to change the speed
  var coords = '-' + (scrolled / 100);

  parallax.forEach(e=> {
    if (inViewport(e)) {
        // e.style.transform = 'translateY(' + coords + ')';
        e.style.backgroundPosition = '50% ' + window.pageYOffset/150 + 'px';
    }
  })
};



var VerticalScrollBlockerMixin = {
    _blockVerticalScroll(threshold = 18) {
    this.addEventListener("touchstart", (event) => {
    this.firstTouchClientX = event.touches[0].clientX;
    }, {passive: true});
    
    this.addEventListener("touchmove", (event) => {
    const touchClientX = event.touches[0].clientX - this.firstTouchClientX;
    if (Math.abs(touchClientX) > threshold) {
    event.preventDefault();
    }
    }, { passive: true });
    
    }
};

var main = function () {

    return {
        rotator: ()=> {
            if ( document.querySelectorAll('.rotate').length > 0) {
                window.onscroll = function() {
                    var rotate = document.querySelectorAll('.rotate')
                    rotate.forEach(e=> {
                        if (inViewport(e)) {
                            e.style.transform = "rotate(" + window.pageYOffset/30 + "deg)";
                        }
                    })
                }
            }
        },
        spaceHeader: ()=> {
          var announcement = document.getElementById('shopify-section-announcement-bar')
          var header = document.querySelector('#shopify-section-header')
          if( announcement != null ) {
            header?.classList.add('has-announcement')
            header?.style.setProperty('--ann-spacing', announcement.clientHeight + "px");
          }
        },
        revAppender: ()=> {
          if ( document.querySelector('#judgeme_product_reviews') != null && document.querySelector('.reviews-appender') != null ) {
            document.querySelector('.reviews-appender').insertAdjacentElement('beforeend', document.querySelector('#judgeme_product_reviews'))
          }

          if (document.querySelector('.vid-appender') != null) {
            document.querySelector('.vid-appender').insertAdjacentElement('beforeend', document.querySelector('.video-section'))
          }
          // Function to move the .cta element to .place-on-mb element
          function moveCtaToMobile() {
            const ctaElements = document.querySelectorAll('.place-on-mb');
            ctaElements.forEach(e => {
              const parent = e.closest('.img-wtxt-content');
              const cta = parent.querySelector('.center-cta-button');
              console.log(cta);

              if (e instanceof Node && cta instanceof Node) {
                e?.appendChild(cta);
              }
            });
          }

          // Function to move the .cta element back to its original position
          function moveCtaBack() {
            const ctaElements = document.querySelectorAll('.place-on-mb');
            ctaElements.forEach(e => {
              const parent = e.closest('.img-wtxt-content');
              const cta = parent.querySelector('.center-cta-button');
              console.log(cta)

              if (cta && cta.parentElement !== parent.querySelector('.cta-container')) {
                parent?.appendChild(cta);
              }
            });
          }


          // Check window width and perform actions accordingly
          function checkWindowWidth() {
            const windowWidth = window.innerWidth;
            if (windowWidth <= 749) {
              moveCtaToMobile();
            } else {
              moveCtaBack();
            }
          }

          // Initial check when the page loads
          window.addEventListener('load', checkWindowWidth);

          // Listen for window resize events
          window.addEventListener('resize', checkWindowWidth);
        },
        scrollView: ()=> {
          document.querySelectorAll('a[href*="#"]').forEach(e => {
              e.addEventListener('click', function (evt) {
                  evt.preventDefault();
          
                  const href = e.getAttribute('href');
                  const fragment = href.split('#')[1]; // Extract the fragment identifier
          
                  if (fragment) {
                      const el = document.getElementById(fragment);
          
                      if (el) {
                          var topPosition = el.getBoundingClientRect().top + window.scrollY;
          
                          // Scroll to the top position with smooth behavior
                          window.scrollTo({
                              top: topPosition,
                              behavior: 'smooth'
                          });
                      } else {
                          console.log('Element not found');
                      }
                  }
              });
          });
        }
    }; 
}()

main.rotator()
main.spaceHeader()
main.revAppender()
main.scrollView()

window.addEventListener('resize', function(event) {
  main.spaceHeader()
}, true);


window.addEventListener("UpdateQty", function(e) {
  var input = e.detail.item
  const baseProduct = parseInt(input.dataset.product)
  const freeProduct = parseInt(input.dataset.freeProduct)
  const freeMainProduct = parseInt(input.dataset.freeProductId)
  const freeThreshold = parseInt(input.dataset.threshold) * 100


  if ( typeof(input.dataset.freeProduct) != undefined && input.dataset.freeProduct != null ) {
      fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const base = data.items.filter(item=> item.product_id == baseProduct)
        const sum = base.reduce((a, b) => b.final_line_price + a, 0);
        const freeIncart = data.items.filter(item=> item.product_id == freeMainProduct)


        if ( sum >= freeThreshold && freeIncart.length == 0 ) {
          
          let freeData = {
            'items': [{
              'id': freeProduct,
              'quantity': 1
              }]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(freeData)
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
            console.log('Free Product added')
            location.reload();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        } 
        else if ( sum < freeThreshold && freeIncart.length >= 1 ) {
          console.log(freeIncart[0].variant_id + ':' + freeIncart[0].key)
          let freeData = {
              'id': freeIncart[0].key,
              'quantity': 0
          };
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(freeData)
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
            console.log('Free Product removed')
            location.reload();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      });
  }
})

document.addEventListener("addToCartButtonClicked", () => {
  const crInterval= setInterval(()=> {
  const popup = document.querySelector("#candyrack-frame")
  const upgradedBtn = popup?.contentDocument?.querySelector('.Button-Add-Added') || undefined
  if (upgradedBtn){
    popup?.contentDocument?.querySelector('[data-cy="continue-button"]').click()
    clearInterval(crInterval)
  }
  },100)
})

function startTimer(duration, display) {
  var timer = duration, minutes, seconds;
  var submitButton = document.querySelector('.product-form__submit');
  var stickySubmit = document.querySelector('.sticky-add-to-cart');

  var intervalId = setInterval(function () {
    minutes = parseInt(timer / 60, 10);
    seconds = parseInt(timer % 60, 10);

    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    display.textContent = minutes + ":" + seconds;

    if (--timer < 0) {
      clearInterval(intervalId);
      if (submitButton != null) {
        submitButton.disabled = true;
      }
      if (stickySubmit != null) {
        stickySubmit.disabled = true;
      }
    }
  }, 1000);
}

window.onload = function () {
  var fiveMinutes = 60 * 10,
      display = document.querySelectorAll('.timer-count');
      display.forEach(e=> {
        startTimer(fiveMinutes, e);
      })
};

document.querySelector('[name="tag_filter"]')?.addEventListener('change', function() {
  window.location.href = this.value;
});

document.querySelectorAll('.order-section slider-component [role="list"]').forEach(e=> {
  e.scrollLeft = e.clientWidth / 2
})

document.querySelectorAll('.order-section slider-component').forEach(e=> {
  e.addEventListener('slideChanged', function(event) {

    if (event.detail.currentElement != undefined || detail.detail.currentElement != null) {
        const ActiveLabel = event.detail.currentElement.querySelector('.order-variant')
        ActiveLabel?.click()
    }
  })
})

document.querySelectorAll('a[href*="#"]').forEach(link => {
  link.addEventListener('click', function(evt) {
    evt.preventDefault();

    console.log('asas')

    // Get the target element by its id
    const targetId = link.getAttribute('href').substring(1); // Remove the '#' from the href
    const targetElement = document.getElementById(targetId);

    // Scroll to the target element
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth', // You can change this to 'auto' for an instant scroll
        block: 'start', // Align the top of the element with the top of the viewport
      });
    }
  });
});